import generify from './generic'

export const maps = generify('experiences-service', 'maps', 'map')

maps.getFromExperience = (experienceUid, showDeleted) => {
  return maps.getFrom('experiences', experienceUid, showDeleted)
}
